import React, {useEffect, useState} from 'react';
import UserAvatar from '../common/components/UserAvatar';
import Button from '../common/components/Button';
import TextInput from '../common/components/TextInput';
import Select from 'react-select';
import BackIcon from  '../../assests/img/left-angle-bracket.svg?react';
import {userDataType} from './UserContent';
import ChangeRole from './ChangeRolePopup';
import DeactivateUserPopup from './DeactivateUserPopup';
import CustomDropdownIndicator from '../common/components/CustomDropdownIndicator';


interface manageUserProps {
    userData: userDataType,
    userRoles: {userRoleId: string, userRoleName: string}[]
    onClickBack: () => void,
    onDeactivateUser: (userId: string, userStatus: boolean) => void,
    onSubmit: (userData: userDataType) => void,
}

function ManageUser(props: manageUserProps) {
    const {userData, userRoles, onClickBack,
        onDeactivateUser, onSubmit} = props;

    const [
        user,
        setUser,
    ] = useState<userDataType>({
        createdOn: '',
        updatedOn: '',
        lastLogin: '',
        userStatus: false,
        userRoleId: '',
        userRoleName: '',
        firstName: '',
        lastName: '',
        email: '',
        id: 0,
        azureUserId: '',
    });

    const [
        showChangeRolePopup,
        setShowChangeRolePopup,
    ] = useState<boolean>(false);

    const [
        showDeactivatePopup,
        setShowDeactivatePopup,
    ] = useState<boolean>(false);

    useEffect(() => {
        setUser({...userData});
    }, [
        userData,
    ]);

    const handleChange = (value: string, field: keyof userDataType) => {
        setUser((prevState) => {
            return {
                ...prevState,
                [field]: value,
            }
        });
    };

    const handleSelectRole = (role: any) => {
        setShowChangeRolePopup(userData.userRoleId !== role.value &&
            userData.userRoleName !== role.label);
        setUser((prevState) => {
            return {
                ...prevState,
                userRoleId: role.value,
                userRoleName: role.label,
            }
        });
    };

    const enableSubmit = () => {
        return user.firstName === userData.firstName &&
        user.lastName === userData.lastName &&
        user.email === userData.email &&
        user.userRoleId === userData.userRoleId;
    };

    const handleUndo = () => {
        setUser((prevState) => {
            return {
                ...prevState,
                userRoleId: userData.userRoleId,
                userRoleName: userData.userRoleName,
            };
        });
        setShowChangeRolePopup(false);
    };

    const handleDeactivate = (userId: string) => {
        setShowDeactivatePopup(false);
        onDeactivateUser(userId, user.userStatus);
    };

    const handleSubmit = () => {
        if (!enableSubmit()) {
            onSubmit(user);
        }
    };

    return (
        <>
        <ChangeRole
            showPopup={showChangeRolePopup}
            onClose={handleUndo}
            onChangeRole={() => setShowChangeRolePopup(false)}
            userRoleId=''
        />
        <DeactivateUserPopup
            userId={user.id.toString()}
            email={user.email}
            userStatus={user.userStatus}
            showPopup={showDeactivatePopup}
            onClose={() => setShowDeactivatePopup(false)}
            deactivateUser={handleDeactivate}
        />
        <div className='manage-user-detail-page'>
            <div className='manage-user-detail-header'>
                <div onClick={onClickBack} className='cta-cursor px-2 d-flex align-items-center justify-content-center'>
                    <BackIcon/>
                </div>
                <span className='ms-1'>Manage User</span>
            </div>
                <div className='manage-user-detail-content'>
                <div className='manage-user-top-content'>
                    <UserAvatar name={`${userData.firstName} ${userData.lastName}`} email={userData.email}/>
                    <div className='d-flex align-items-center gap-2'>
                        {/* <Button
                            buttonText='Reset Password'
                            onClick={() => false}
                            buttonIconUrl={LockIcon}
                            type='secondary'/> */}
                        <Button
                            buttonText={user.userStatus ? 'De-activate User' : 'Activate User'}
                            onClick={() => setShowDeactivatePopup(true)}
                            type='secondary'/>
                        <Button
                            buttonText='Submit Changes'
                            onClick={handleSubmit}
                            disable={enableSubmit()}
                            type='primary'/>
                    </div>
                </div>
                <div className='manage-user-bottom-content'>
                    <div className='manage-user-bottom-content-header'>Personal</div>
                    <div className='d-flex align-items-center justify-content-center gap-2'>
                        <div className='w-25'>
                            <label className='form-label'>Fisrt Name</label>
                            <TextInput type='text'
                            placeholder='Enter First Name'
                            onChange={(text) => handleChange(text, 'firstName')}
                            text={user.firstName}
                            style={{width: '100%'}}/>
                        </div>
                        <div className='w-25'>
                            <label className='form-label'>Last Name</label>
                            <TextInput type='text'
                            placeholder='Enter Last Name'
                            onChange={(text) => handleChange(text, 'lastName')}
                            text={user.lastName}
                            style={{width: '100%'}}/>
                        </div>
                        <div className='w-25'>
                            <label className='form-label'>Email ID</label>
                            <TextInput type='text'
                            placeholder='Enter Email ID'
                            onChange={(text) => handleChange(text, 'email')}
                            text={user.email}
                            style={{width: '100%'}}/>
                        </div>
                        <div className='w-25'>
                            <label className='form-label'>Role</label>
                            <Select
                                options={userRoles.map((role) => {
                                    return {value: role.userRoleId,
                                        label: role.userRoleName}
                                })}
                                value={{value: user.userRoleId,
                                    label: user.userRoleName}}
                                placeholder={'Select Role'}
                                isSearchable
                                onChange={handleSelectRole}
                                className='input-select'
                                components={{
                                    DropdownIndicator: CustomDropdownIndicator}}
                                styles={{
                                    indicatorSeparator: (base) => ({
                                        ...base,
                                        display: 'none',
                                    }),
                                }}
                            ></Select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </>
    );
}

export default ManageUser;
